import { render, staticRenderFns } from "./mastery-question-objective-header-actions.vue?vue&type=template&id=1c0bda7a&scoped=true"
import script from "./mastery-question-objective-header-actions.ts?vue&type=script&lang=ts&external"
export * from "./mastery-question-objective-header-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./mastery-question-objective-header-actions.less?vue&type=style&index=0&id=1c0bda7a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bda7a",
  null
  
)

export default component.exports